import axios from "axios";
import { isBrowser, safeRedirect } from "./utils/runtime";

const AUTH_EXPIRED_EVENT = "sevenly:auth-expired";
const AUTH_PUBLIC_ENDPOINTS = ["/admin-login", "/reset-password", "/auth/session"];

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");
    const isPublicEndpoint = AUTH_PUBLIC_ENDPOINTS.some((endpoint) =>
      requestUrl.includes(endpoint)
    );

    if (status === 401 && !isPublicEndpoint && isBrowser) {
      window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
      if (
        window.location.pathname !== "/" &&
        window.location.pathname !== "/set-password"
      ) {
        safeRedirect("/");
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
